// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import IconSrc from '../../../assets/images/question-white.svg';

const PopupS = {
  Container: styled.div`
    display: flex;
    flex-direction: column;
  `,
  Triangle: styled.div`
    width: 0;
    margin-left: 129px;
    border-style: solid;
    border-width: 0 7px 9px 7px;
    border-color: transparent transparent #434343 transparent;
    border-radius: 1px;
  `,
  Content: styled.p`
    width: 223px;
    padding: 12px 15px;
    font-size: 14px;
    line-height: 20px;
    color: #FFFFFF;
    background: #434343;
    border-radius: 4px;
  `,
}

const Popup: React.FC<React.ComponentPropsWithRef<'div'>> = (props) => {
  return (
    <PopupS.Container {...props}>
      <PopupS.Triangle/>
      <PopupS.Content>
        <FormattedMessage id="E026" values={{ br: <br/> }} />
      </PopupS.Content>
    </PopupS.Container>
  )
}

const S = {
  Container: styled.div`
    display: flex;
    position: relative;
  `,
  Icon: styled.img.attrs({ src: IconSrc })`
    width: 24px;
    cursor: pointer;
  `,
  Popup: styled(Popup)`
    position: absolute;
    left: -124px;
    top: 29px;
  `,
}

function useClosePopup<T extends HTMLElement>(isPopupShow: boolean, closePopup: () => void) {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (!isPopupShow) return;

    function handleClosePopup(e: MouseEvent) {
      console.log(ref.current, e.target)
      if (!ref.current?.contains(e.target as Node)) {
        closePopup();
      }
    }

    window.addEventListener('click', handleClosePopup);

    return () => {
      window.removeEventListener('click', handleClosePopup);
    }
  }, [isPopupShow, closePopup, ref.current])

  return ref;
}

const Notion: React.FC<React.ComponentPropsWithRef<'div'>> = props => {
  const [isPopupShow, setPopupShow] = useState(false);
  const closePopup = useCallback(() => setPopupShow(false), [])
  const ref = useClosePopup<HTMLDivElement>(isPopupShow, closePopup);
  const togglePopup = useCallback((e: React.MouseEvent) => {
    e.stopPropagation();
    setPopupShow(!isPopupShow)
  }, [isPopupShow]);

  return (
    <S.Container ref={ref} {...props}>
      <S.Icon onClick={togglePopup}/>
      {isPopupShow && <S.Popup />}
    </S.Container>
  )
}

export { Notion as default };
